// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec576d94","711":"ddc92802","897":"0512a34e"}[chunkId] + ".chunk.js";
};